import React from "react";
import Grid from "@material-ui/core/Grid";
import { TextValidator } from 'react-material-ui-form-validator';
import Typography from "@material-ui/core/Typography";

import useGroupSetting from "Hooks/useGroupSetting";
import { message } from "constants/message";

export default function Burst({
  state,
  onChangeUnit,
  onChangeTarget,
  onChangeRatio,
}) {
  const groupSetting = useGroupSetting();
  const messages = message();

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Typography>
            ※直近の単位時間の収集件数と、対象期間の同じ時間帯の平均収集件数の比率が設定値以上の場合に通知されます
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography value="h6">単位時間</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <TextValidator
              onChange={onChangeUnit}
              value={state.alert_params && state.alert_params.unit ? 
                state.alert_params.unit : 
                groupSetting.setData("unit", 1)}
              type="number"
              style={{ width: 220 }}
              InputProps={{ inputProps: { min: 1} }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "単位時間")).replace("$2", "1")
              ]}
            />
            <Typography value="span">時間</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">対象期間</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <TextValidator
              onChange={onChangeTarget}
              value={state.alert_params && state.alert_params.target ? 
                state.alert_params.target : 
                groupSetting.setData("target", 7)}
              type="number"
              style={{ width: 220 }}
              InputProps={{ inputProps: { min: 1} }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "対象期間")).replace("$2", "1")
              ]}
            />
            <Typography value="span">日間</Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={2}>
          <Typography value="h6">比率</Typography>
        </Grid>
        <Grid item xs={10}>
          <Grid container>
            <TextValidator
              onChange={onChangeRatio}
              value={state.alert_params && state.alert_params.ratio ? 
                state.alert_params.ratio : 
                groupSetting.setData("ratio", 200)}
              type="number"
              style={{ width: 220 }}
              InputProps={{ inputProps: { min: 1} }}
              validators={['required', 'minNumber:1']}
              errorMessages={[
                messages.validation.required, 
                ((messages.validation.minNumber).replace("$1", "比率")).replace("$2", "1")
              ]}
            />
            <Typography value="span">％</Typography>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
